import netteForms from 'nette-forms';

export default {
	init() {
		/*
			ToDo: V budoucnu prozkoumat

			// Custom validátory
			netteForms.validators.czechPhone = function(elem, arg, value) {
				return /^(\+420)?[0-9]{9}$/.test(value);
			};

			// Custom error handling
			netteForms.showFormErrors = function(form, errors) {
				// Vaše vlastní zobrazení chyb
				console.log('Form errors:', errors);
			};
		*/

		// Inicializace
		netteForms.initOnLoad();
	}
}
